<div appMobileResizeFix>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-question-circle"
    appendTo="body"
    [autoZIndex]="false"
    [style]="{ 'z-index': 1125 }"
    acceptButtonStyleClass="p-button-success"
    acceptLabel="Yes"
    rejectButtonStyleClass="p-button-warn"
    rejectLabel="No"
  />
  <spinner />
  <app-toast />
  <router-outlet />
</div>
